import axios from 'axios';

// URL de producción fija - chatmanantial.com
const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:3000'
  : 'https://chatmanantial.com';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para añadir token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // No redirigir si estamos en /xia (tiene su propia autenticación)
      if (!window.location.pathname.startsWith('/xia')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post('/api/auth/login', { email, password });

export const getMe = () =>
  api.get('/api/auth/me');

export const changePassword = (currentPassword, newPassword) =>
  api.post('/api/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword
  });

// Users
export const getUsers = (params) =>
  api.get('/api/users', { params });

export const getUser = (id) =>
  api.get(`/api/users/${id}`);

export const createUser = (userData) =>
  api.post('/api/auth/register', userData);

export const updateUser = (id, userData) =>
  api.put(`/api/users/${id}`, userData);

export const deleteUser = (id) =>
  api.delete(`/api/users/${id}`);

// Departments
export const getDepartments = () =>
  api.get('/api/departments');

export const getDepartment = (id) =>
  api.get(`/api/departments/${id}`);

export const getDepartmentUsers = (id) =>
  api.get(`/api/departments/${id}/users`);

// AI
export const chatWithAI = (message, conversationHistory = [], customContext = '', webSearch = false) =>
  api.post('/api/ai/chat', { message, conversationHistory, customContext, webSearch });

// Text-to-Speech
export const textToSpeech = (text, voice = 'es-ES-ElviraNeural') =>
  api.post('/api/ai/tts', { text, voice });

export const getTTSVoices = () =>
  api.get('/api/ai/tts/voices');

export const getAIStatus = () =>
  api.get('/api/ai/status');

export const updateAIKnowledge = (knowledge) =>
  api.post('/api/ai/update-knowledge', { knowledge });

// Tasks
export const getTasks = () =>
  api.get('/api/tasks');

export const getTasksByDepartment = (deptId) =>
  api.get(`/api/tasks/department/${deptId}`);

export const createTask = (taskData) =>
  api.post('/api/tasks', taskData);

export const updateTask = (id, taskData) =>
  api.put(`/api/tasks/${id}`, taskData);

export const deleteTask = (id) =>
  api.delete(`/api/tasks/${id}`);

// Knowledge
export const getKnowledge = (params) =>
  api.get('/api/knowledge', { params });

export const getKnowledgeForAI = (departmentId) =>
  api.get('/api/knowledge/for-ai', { params: { department_id: departmentId } });

export const createKnowledge = (data) =>
  api.post('/api/knowledge', data);

// Fichador (Time Clock)
export const getFichadorStatus = () =>
  api.get('/api/fichador/status');

export const fichadorClockIn = (note = '') =>
  api.post('/api/fichador/clock-in', { note });

export const fichadorClockOut = (note = '') =>
  api.post('/api/fichador/clock-out', { note });

export const fichadorBreakStart = (breakType = 'descanso', note = '') =>
  api.post('/api/fichador/break-start', { breakType, note });

export const fichadorBreakEnd = (note = '') =>
  api.post('/api/fichador/break-end', { note });

export const getFichadorHistory = (startDate, endDate, userId = null) =>
  api.get('/api/fichador/history', { params: { startDate, endDate, userId } });

export const getFichadorReport = (month, year, userId = null) =>
  api.get('/api/fichador/report', { params: { month, year, userId } });

// Notifications
export const getNotifications = () =>
  api.get('/api/notifications');

export const markNotificationRead = (id) =>
  api.put(`/api/notifications/${id}/read`);

export const deleteNotification = (id) =>
  api.delete(`/api/notifications/${id}`);

export const deleteAllNotifications = () =>
  api.delete('/api/notifications');

export default api;
